export enum VendorType {
    INFONET = 'infonet',
    LIST = 'list',
    AUDAX = 'audax',
    VIZIJA = 'vizija',
    MEDICAL = 'medical',
}
